'use client'

import { HOUSE_FILTER_ALIAS } from '@config'
import { RESIDENTIAL_FILTER } from '@homeSearch/modules/filter/config'
import PriceContent from '@homeSearch/modules/filter/content/list/item/price/content'
import useFetch from '@hooks/useFetch'
import useProgressRouter from '@hooks/useProgressRouter'
import { filterToString, mergeFilter, priceToAlias, removeFilterAlias } from '@plugin/searchRoute/modules/house'
import { global } from '@store/index'
import { getPriceLabel, toNumber, toPrice } from '@utils'
import { assign, find, get, isArray, isEqual, isUndefined, map, size, split } from 'lodash-es'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useList } from 'react-use'
import { useRecoilValue } from 'recoil'
import useHouseSearchContext from '../../../context'
import FilterItemBase, { getFilterRouter, getFilterTotals } from '../../base'
import useParamsToFilter from '../../useParams2filter'

export default function FilterPrice() {

  const { isMobile } = useRecoilValue(global)
  const [mobile, setMobile] = useState(false)
  useEffect(() => setMobile(isMobile), [setMobile, isMobile])
  const { state, routeParams, filterMeta } = useHouseSearchContext()
  // 路由上的price数据，用来显示选中效果以及文字内容
  const routePrice = useMemo(() => {
    let { price } = routeParams
    if (!price) return
    price = decodeURIComponent(price)
    const arr = price.includes('-') ? split(price, '-') : split(price, '+')
    return map(arr, item => toNumber(item))
  }, [routeParams])
  // 路由上成price数据转换成文字
  const [routePriceLabel, routePriceTitle] = useMemo(() => {
    let text = 'Price'
    let title = 'Price'
    if (size(routePrice)) {
      text = getPriceLabel(get(routePrice, 0), get(routePrice, 1))
      title = getPriceLabel(get(routePrice, 0), get(routePrice, 1))
      if (mobile) {
        const min = get(routePrice, 0)
        const max = get(routePrice, 1)
        if (!min && max) {
          text = (
            <>
              <i className='icon icon-up inline-block -scale-y-100 !text-xs font-bold'></i>
              {toPrice(max, '', '($0[.]0a)')}
            </>
          )
        } else {
          text = (
            <>
              <i className='icon icon-up !text-xs font-bold'></i>
              {toPrice(min, '', '($0[.]0a)')}
            </>
          )
        }
      }
    }
    return [text, title]
  }, [routePrice, mobile])
  // 当前的price数据，默认是路由上的price数据，用户可以操作此数据
  const [value, { set: setValue, reset: resetValue }] = useList(routePrice)
  // 根据当前选择price生成的参数，每次操作生成不同的参数
  const [filter, query, baseData] = useParamsToFilter({ filterMeta, state })
  const params = useMemo(() => {
    if (!query) return
    const alias = priceToAlias(get(value, 0), get(value, 1), baseData)
    // 删除原来filter上的price，转成string
    const noPriceFilter = filterToString(removeFilterAlias(filter, HOUSE_FILTER_ALIAS.price))
    const conbine = mergeFilter(noPriceFilter, alias)
    return assign({}, query, conbine ? { filter: conbine } : undefined)
  }, [value, filter, query, baseData])
  // 根据动态参数，获取对应数据
  const { data, isLoading } = useFetch(params ? { url: RESIDENTIAL_FILTER.url, params } : null)
  // 当前显示的price data
  const [priceData, setPriceData] = useState()
  // 根据用户选择，设置显示的price data
  useEffect(() => {
    if (!isArray(data) || !size(data)) return
    const d = find(data, item => HOUSE_FILTER_ALIAS.price.includes(item.alias))
    d.totals = getFilterTotals(data)
    setPriceData(d)
  }, [data, setPriceData])

  // price bar发生改变，更新当前priceFrom, priceTo
  const changeHandle = useCallback(({ priceFrom, priceTo }) => {
    if (!isUndefined(priceFrom) || !isUndefined(priceTo)) {
      setValue([priceFrom, priceTo])
    } else {
      setValue([])
    }
  }, [setValue])
  // 确定显示操作
  const { replaceRouter } = useProgressRouter()
  const confirmHandle = useCallback((val) => {
    const { slug } = state
    const [url, newSlug] = getFilterRouter(state)(houseRoute => {
      houseRoute['price-from'] = get(val || value, 0)
      houseRoute['price-to'] = get(val || value, 1)
    })
    if (!isEqual(slug, newSlug)) {
      replaceRouter(url)
    }
  }, [value, replaceRouter, state])
  // 清除选择操作
  const clearHandle = useCallback(() => {
    setValue([])
    confirmHandle([])
  }, [setValue, confirmHandle])

  return (
    <FilterItemBase
      text={routePriceLabel}
      popupTitle={routePriceTitle}
      active={!!size(routePrice)}
      totals={priceData && priceData.totals}
      isLoading={isLoading}
      onClear={clearHandle}
      onClose={resetValue}
      onConfirm={confirmHandle}
    >
      {priceData && <PriceContent data={priceData.children} onChange={changeHandle} height={80} value={value}></PriceContent>}
    </FilterItemBase>
  )
}